import type React from 'react';

import { RegisterButtonsSubsection } from './register-buttons-subsection';
import { StyledSection, StyledGridContainer } from './register-section.styles';

export const RegisterSection: React.FC = () => (
  <StyledSection>
    <StyledGridContainer type="wide">
      <RegisterButtonsSubsection />
    </StyledGridContainer>
  </StyledSection>
);
